module.exports = __webpack_public_path__ + "static/careers-logistics-d95575d1680c0ea0100a2b05560fd8dd.jpg";